import axios from 'axios';

const apiUrl = process.env.REACT_APP_BACKEND_API_URL;


export const getSales = async (teamName: string, yearMonth: string): Promise<string> => {
  const postData = { team_name: teamName, year_month: yearMonth };
  const response = await axios.post(`${apiUrl}/maintenance/getTotalPurchaseByTeamAndDate/`, postData, { withCredentials: true });
  return response.data.total_quantity;
}

export interface TeamSales {
  team_name: string;
  total_quantity: number;
}

// 指定月のチームごとの販売数(販売数0のチームは含まれない。販売数の多い順)
export const getSalesByTeam = async (yearMonth: string): Promise<TeamSales[]> => {
  const postData = { year_month: yearMonth };
  const response = await axios.post(`${apiUrl}/maintenance/getTotalPurchaseByDate/`, postData, { withCredentials: true });
  return response.data.sales;
}
